import { useState, useCallback } from 'react';
import MicRecorder from '@tscole/mic-recorder-to-mp3';

const recorder = new MicRecorder({ bitRate: 128 });
export const useRecorder = () => {
    const [permission, setPermission] = useState(false);
    const [audio, setAudio] = useState<File | null>(null);
    const [isRecording, setIsRecording] = useState(false);

    const getMicrophonePermission = async () => {
        if (navigator.permissions) {
            try {
                const status = await navigator.permissions.query({ name: 'microphone' as PermissionName });
                if (status.state === 'granted' || status.state === 'prompt') {
                    setPermission(true);
                }
            } catch (e) {
                console.warn('Permission API error:', e);
                setPermission(false);
            }
        }
    };

    const startRecording = useCallback(async () => {
        try {
            await recorder.start();
            setIsRecording(true);
        } catch (err) {
            console.error('Error starting recording:', err);
        }
    }, []);

    const stopRecording = useCallback(async () => {
        try {
            const [, blob] = await recorder.stop().getMp3();
            if (blob.size === 0) {
                console.error('No audio data in blob.');
                setIsRecording(false);
                return;
            }
            // turn it to file and convert
            const file = new File([blob], 'recording.mp3', { type: 'audio/mpeg' });
            setAudio(file);
            setIsRecording(false);
            // Send the file to the server or process it as needed
        } catch (err) {
            setIsRecording(false);
            console.error('Error stopping recording:', err);
        }
    }, []);
    return {
        isRecording,
        permission,
        audio,
        getMicrophonePermission,
        startRecording,
        stopRecording,
    };
};
